import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import Icon from 'src/common/components/IconDS22';
import styles from './ActiveFilterPill.module.scss';

type ActiveFilterPillProps = {
  children: ReactNode;
  clearAction: () => void;
  translationKey?: string;
};

const ActiveFilterPill: FC<ActiveFilterPillProps> = ({
  children,
  clearAction,
  translationKey,
}) => {
  const [t] = useTranslation('search-page');
  const title = t(`filter-clear-button-title${translationKey ? `--${translationKey}` : ''}`);

  return (
    <button
      type="button"
      className={styles.root}
      onClick={clearAction}
      title={title}
      aria-label={title}
      data-test={t(`${children}filterpill`)}
    >
      {children}
      <Icon
        id="x"
        size="s"
        className={styles.icon}
      />
    </button>
  );
};

export default ActiveFilterPill;
